window.OrderCutPriceUtils = {
  // 税込対応の統一計算
  // メタフィールドのrateは税込価格なので、計算時に税抜に戻してから使用
  calculateCustomPrice: function(params){
    const TAX = 1.1;
    const w = Math.max(1, params.width||0);
    const h = Math.max(1, params.height||0);
    const q = Math.max(1, params.quantity||1);
    const rateTaxIncluded = Math.max(0.0001, params.unitRate||0.01);

    // メタフィールドのrateは税込なので、税抜に戻す
    const rateExcludingTax = rateTaxIncluded / TAX;

    const base = 7000;
    const material = (w+3)*(h+3)*rateExcludingTax*q;
    const addFee = 2000 * Math.ceil((w+5)*(h+5)*q/600/300);
    const cutFee = 15*q;
    const subtotal = Math.round((base+material+addFee+cutFee)/10)*10;
    const unitPrice = Math.round(subtotal/q);
    const total = Math.round(unitPrice*TAX)*q;
    return { unitPrice, subtotal, total };
  }
};

